import styled, {css, keyframes} from "styled-components";

const fadeInUp = keyframes`
    0% {
        opacity: 0;
        transform: translateY(20px);
    }
    100% {
        opacity: 1;
        transform: translateY(0);
    }
`;

const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;

export const StyledOrderCard = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    border: 1px solid rgba(125, 245, 0, 0.15);
    border-radius: 14px;
    box-shadow: 0 4px 20px rgba(13, 39, 2, 0.08);
    animation: ${fadeInUp} 0.5s ease-out forwards;
    animation-delay: ${props => (props.$index ? `${props.$index * 0.1}s` : "0.05s")};
    overflow: hidden;
    opacity: 0;
    .card-body {
        padding: 10px 20px;
        flex: 1;
        display: flex;
        flex-direction: column;
    }
    .card-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 16px;
        margin-bottom: 10px;
        .count-wrap {
            display: flex;
            align-items: center;
            gap: 16px;
            .count {
                display: flex;
                align-items: center;
                gap: 6px;
                color: var(--text-color);
                font-size: 18px;
                line-height: 22px;
                font-weight: 500;
            }
          
            .dot {
                    display: block;
                    width: 8px;
                    height: 8px;
                    border-radius: 50%;
                    background-color: rgba(44, 185, 255, 1);
                }
            }
            .pickup-code-section {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                gap: 2px;

                .pickup-label {
                    font-size: 10px;
                    font-weight: 500;
                    color: rgba(143, 143, 143, 1);
                    text-transform: uppercase;
                    letter-spacing: 0.5px;
                }

                .pickup-value-wrap {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    padding: 4px 10px;
                    background: rgba(0, 0, 0, 0.04);
                    border-radius: 6px;

                    .pickup-value {
                        font-size: 14px;
                        font-weight: 600;
                        color: var(--text-color);
                        letter-spacing: 0.5px;
                    }

                    .copy-icon {
                        width: 14px;
                        height: 14px;
                        cursor: pointer;
                        opacity: 0.5;
                        transition: opacity 0.2s ease;

                        &:hover {
                            opacity: 1;
                        }
                    }
                }
            }
            .status {
                padding: 5px 12px;
                border-radius: 20px;
                font-size: 13px;
                line-height: 17px;
                font-weight: 700;
                background: rgba(0, 0, 0, 0.12);
                color: inherit;
                letter-spacing: 0.2px;
            }
            .cancelled {
                background: rgba(255, 255, 255, 0.18);
            }
        }
        .time-wrap {
            display: flex;
            align-items: center;
            gap: 5px;
            background: rgba(0, 0, 0, 0.12);
            padding: 4px 10px;
            border-radius: 20px;
            .time {
                color: inherit;
                font-size: 12px;
                line-height: 16px;
                font-weight: 600;
            }
        }
    }
    .details-wrapper {
        display: flex;
        gap: 10px;
        align-items: start;
        justify-content: space-between;

    }
    .details-list {
        list-style: none;

         
        li {
            display: flex;
            align-items: center;
            gap: 13px;
            margin-bottom: 10px;
            font-size: 16px;
            line-height: 20px;
            font-weight: 300;
            color: var(--text-color);

            strong {
                font-weight: 500;
            }
        }
    }
    .items-list {
        list-style: none;
        margin-bottom: 15px;
        max-height: 100px;
        overflow-y: auto;
        padding-right: 8px;
        margin-right: -8px;

        /* Custom Scrollbar for a premium look */
        &::-webkit-scrollbar {
            width: 4px;
        }
        &::-webkit-scrollbar-track {
            background: rgba(0, 0, 0, 0.05);
            border-radius: 10px;
        }
        &::-webkit-scrollbar-thumb {
            background: rgba(0, 0, 0, 0.1);
            border-radius: 10px;
            &:hover {
                background: rgba(0, 0, 0, 0.2);
            }
        }

        li {
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap: 16px;
            margin-bottom: 12px;
            font-size: 16px;
            line-height: 20px;
            font-weight: 300;
            color: var(--text-color);
            .add-on {
                color: rgba(245, 126, 42, 1);
                font-size: 15px;
                line-height: 19px;
                font-weight: 500;
            }
        }
    }
    .price-wrap {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 16px;
        margin-bottom: 20px;
        margin-top: auto;
        .order-type-wrap {
            display: flex;
            align-items: center;
            gap: 10px;
            font-size: 14px;
            line-height: 18px;
            font-weight: 500;
            flex-wrap: wrap;
            .order-type {
                padding: 7px 10px;
                border: 1px solid rgba(125, 245, 0, 0.3);
                border-radius: 30px;
                color: #0D2702;
                background: rgba(125, 245, 0, 0.08);
                text-transform: capitalize;
                white-space: nowrap;
                font-weight: 500;
            }
            .external-order {
                padding: 7px 10px;
                border-radius: 30px;
                color: #242424;
                background-color: #7DF500;
                white-space: nowrap;
                font-weight: 600;
            }
            .foodie {
                padding: 7px 10px;
                border-radius: 30px;
                color: #242424;
                background-color: #7DF500;
                white-space: nowrap;
                font-weight: 600;
            }
        }
        .price {
            color: var(--text-color);
            font-size: 18px;
            line-height: 22px;
            font-weight: 600;
        }
    }
    .btn-wrap {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        margin-bottom: 15px;
        flex-wrap: wrap;
        
        .view-details-link {
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 10px;
            background: transparent;
            border: 1px solid rgba(200, 200, 200, 0.5);
            border-radius: 30px;
            padding: 10px 24px;
            color: rgba(143, 143, 143, 1);
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.2s ease;
            
            img {
                width: 16px;
                height: 16px;
                opacity: 0.6;
            }
            
            &:hover {
                background: rgba(0, 0, 0, 0.03);
                border-color: rgba(150, 150, 150, 0.6);
            }
        }
    }
    .loading-spinner {
        display: inline-block;
        width: 14px;
        height: 14px;
        border: 2px solid rgba(255, 255, 255, 0.3);
        border-radius: 50%;
        border-top-color: #fff;
        animation: ${spin} 0.8s linear infinite;
    }
    .tooltip {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        cursor: pointer;


         .booking-code-wrap {
                display: flex;
                align-items: center;
                gap: 8px;
                margin: 0 0 4px 0;
                padding: 4px 8px;
                background: rgba(0, 0, 0, 0.03);
                border-radius: 4px;
                
                .booking-code-label {
                    font-size: 12px;
                    color: #666;
                }
                
                .booking-code-value {
                    font-size: 12px;
                    font-weight: 500;
                    color: #333;
                }
            }
            
            .order-id-wrap {
                display: flex;
                align-items: center;
                gap: 6px;
            }
            
            .tracking-id {
                font-size: 12px;
                font-weight: 400;
                color: rgba(119, 119, 119, 1);
                margin-top: 2px;
            }
            
            .order-id {
                font-size: 18px;
                font-weight: 500;
                color: var(--text-color);
            }
    }

    .tooltip-text {
        visibility: hidden;
        width: auto;
        max-width: 300px;
        background-color: black;
        color: #fff;
        text-align: center;
        border-radius: 6px;
        padding: 5px 8px;
        font-size: 12px;
        line-height: 1.4;
        position: absolute;
        z-index: 1;
        bottom: 125%; /* show above the text */
        left: 50%;
        transform: translateX(-50%);
        opacity: 0;
        transition: opacity 0.2s;
        white-space: nowrap; /* keep long ID on one line */
    }

    .tooltip:hover .tooltip-text {
        visibility: visible;
        opacity: 1;
    }

    .separator {
        width: 100%;
        border-bottom: 1px solid rgba(236, 236, 236, 1);
    }

    .prep-time-stepper {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 14px;
        background: rgba(0, 0, 0, 0.03);
        border: 1px solid rgba(0, 0, 0, 0.06);
        padding: 8px 14px;
        border-radius: 10px;

        .label {
            font-size: 13px;
            font-weight: 500;
            color: #555;
        }

        .stepper-controls {
            display: flex;
            align-items: center;
            gap: 10px;

            button {
                background: #fff;
                border: 1px solid #e0e0e0;
                border-radius: 6px;
                width: 30px;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 2px;
                cursor: pointer;
                font-size: 11px;
                font-weight: 600;
                color: #333;
                transition: all 0.2s;

                &:hover {
                    border-color: #bbb;
                    background: #f5f5f5;
                }
            }

            .value {
                min-width: 38px;
                text-align: center;
                font-weight: 700;
                color: #222;
                font-size: 15px;
            }
        }
    }
`;

export const CardHeader = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    min-height: 52px;
    background-color: var(--primary);
    border-radius: 14px 14px 0 0;
    color: #242424;

    .status {
        padding: 5px 12px;
        border-radius: 20px;
        font-size: 13px;
        line-height: 17px;
        font-weight: 700;
        background: rgba(0, 0, 0, 0.12);
        color: inherit;
        letter-spacing: 0.2px;
    }

    .time-wrap {
        display: flex;
        align-items: center;
        gap: 5px;
        background: rgba(0, 0, 0, 0.12);
        padding: 4px 10px;
        border-radius: 20px;
        .time {
            color: inherit;
            font-size: 12px;
            line-height: 16px;
            font-weight: 600;
        }
    }

    .timer-badge {
        background: rgba(0, 0, 0, 0.15);
        padding: 4px 10px;
        border-radius: 20px;
        font-size: 12px;
        font-weight: 600;
        display: flex;
        align-items: center;
        gap: 4px;
        color: inherit;

        &.overdue {
            background: rgba(211, 47, 47, 0.15);
            color: #D32F2F;
        }
    }

    .header-print-btn {
        &:hover {
            background: rgba(0, 0, 0, 0.1) !important;
            transform: scale(1.05);
        }
        &:active {
            transform: scale(0.95);
        }
    }

    ${({$status}) =>
        $status === "pending" &&
        css`
            background-color: var(--primary);
            color: #0d2702;
        `}
    ${({$status}) =>
        $status === "preparing" &&
        css`
            background-color: rgba(44, 185, 255, 1);
            color: #fff;
        `}
    ${({$status}) =>
        $status === "ready" &&
        css`
            background-color: #0D2702;
            color: #7DF500;
        `}
    ${({$status}) =>
        $status === "completed" &&
        css`
            background-color: rgba(119, 119, 119, 1);
            color: #fff;
        `}
    ${({$status}) =>
        $status === "delivery" &&
        css`
            background-color: rgba(94, 64, 153, 1);
            color: #fff;
        `}
    ${({$status}) =>
        $status === "out_for_delivery" &&
        css`
            background-color: rgba(245, 126, 42, 1);
            color: #fff;
        `}
    ${({$status}) =>
        $status === "accepted" &&
        css`
            background-color: #8527c4ff;
            color: #fff;
        `}
    ${({$status}) =>
        $status === "cancelled" &&
        css`
            background-color: #d32f2f;
            color: #fff;
        `}
`;
